import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import apiClient from 'apiClient';
import { translate } from 'translations/i18n';

import {
  REACT_SELECT_STYLES,
  PROJECT_FORM_SELECT_STYLES,
} from 'helpers/styles';
import { LD_IMPROVE_PROJECT_TEMPLATE_DISCOVERABILITY } from 'constants/featureFlags';
import { useFlags } from 'launchdarkly-react-client-sdk';

const DataSelect = (props) => {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const flags = useFlags();
  const enableImprovedProjectTemplateDiscoverability =
    flags[LD_IMPROVE_PROJECT_TEMPLATE_DISCOVERABILITY];

  const { endpoint } = props;

  useEffect(() => {
    if (!endpoint) {
      console.error('No endpoint provided for DataSelect');
    }
    setLoading(true);
    setOptions([]);
    apiClient.get(endpoint).then((data) => {
      setOptions(data);
      setLoading(false);
    });
  }, [endpoint]);

  const onChange = (opt) => {
    if (typeof props.onChange === 'function') {
      const value = opt ? opt.value : '';
      props.onChange(value);
    }
  };

  const loadingPlaceholder = translate('common.loading');

  const currentValue = props.value || props.defaultValue;

  return (
    <ReactSelect
      isLoading={loading}
      isClearable={false}
      isDisabled={props.disabled}
      styles={
        enableImprovedProjectTemplateDiscoverability
          ? PROJECT_FORM_SELECT_STYLES
          : REACT_SELECT_STYLES
      }
      name={props.name}
      placeholder={loading ? loadingPlaceholder : props.placeholder}
      value={options.find((type) => type.value === currentValue) || ''}
      options={options}
      onChange={onChange}
    />
  );
};

DataSelect.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

DataSelect.defaultProps = {
  onChange: () => {},
  value: null,
  placeholder: '',
  disabled: false,
};

export default DataSelect;
